// B7 Tier 0 — owner nameplate management API (plan §6.1 + §6A.5). Machinery
// service. Every endpoint is tenant-ownership-checked server-side and gated on
// Machinery:Write (raised from Read by SEC-REQ-B7-12 — Read wrongly admitted
// Worker and Viewer), so a Worker/Viewer call returns 403. Callers must gate on
// canWrite before dispatching.
import api from "../../../core/api";
import { NameplateFleetItem, NameplateStatus } from "../models/nameplateModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
};

class CustomerNameplatesApi {
  /** B7-BE4 fleet list — one row per non-decommissioned machine. Exists so the
   *  Settings fleet table never fans out N per-machine GETs. Carries no code and
   *  no idLink (SEC-REQ-B7-13). */
  getFleet(): Promise<NameplateFleetItem[]> {
    return api
      .get<NameplateFleetItem[]>(`v1/customer/machines/nameplates`, getRequestConfig())
      .then((x) => x.data);
  }

  /** §6.1 per-machine detail — the ONLY source of the link + QR payload. Called
   *  on a user-initiated row expand, never on render for the whole fleet. */
  getNameplate(machineId: string): Promise<NameplateStatus> {
    return api
      .get<NameplateStatus>(`v1/customer/machines/${machineId}/nameplate`, getRequestConfig())
      .then((x) => x.data);
  }

  /** Sets the flag AND atomically mints a code if none is active. */
  enableNameplate(machineId: string): Promise<NameplateStatus> {
    return api
      .post<NameplateStatus>(
        `v1/customer/machines/${machineId}/nameplate/enable`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  /** Clears the flag. The code stays active-but-dark — re-enabling restores the
   *  same plate with no reprint. */
  disableNameplate(machineId: string): Promise<NameplateStatus> {
    return api
      .post<NameplateStatus>(
        `v1/customer/machines/${machineId}/nameplate/disable`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  // NO regenerate method here, and no client may add one — owner ruling
  // 2026-08-11 (B7 plan §6A.1 D3). The verbatim guard note lives at the UI site
  // it would occupy: NameplateRowDetailV2.tsx.
}

export default new CustomerNameplatesApi();
